module.exports = __webpack_public_path__ + "static/media/backscreen.1320aa23.png";